import React from 'react';

import { V5_DOWNLOAD_ICON_TRIAL } from '@shared/config/constants/api-sources';
import { isAE, isMY } from '@entities/country/model/utils';
import { useAtomValue } from 'jotai';
import { dcbAtom } from '@shared/store/slice-atoms';
import { useTranslation } from 'react-i18next';
import { useCheckMarkLYCondition } from '@features/phone-subscription/model/hooks/useCheckMarkLYCondition';
import styles from '../styles/BannerTitleV5.module.css';

const URL_REFERRER_SS_NAME = 'urlReferrer';

interface Props {
  subTitle: string;
}

export const BannerTitleV5: React.FC<Props> = (props) => {
  const { subTitle } = props;
  const { t } = useTranslation();

  const { homeData } = useAtomValue(dcbAtom);
  const { isCheckMarkLY } = useCheckMarkLYCondition();

  const SSUrlReferrer = sessionStorage.getItem(URL_REFERRER_SS_NAME);
  const partUrl = window.location.pathname && SSUrlReferrer ? SSUrlReferrer : null;

  const locationPath = partUrl || window.location.pathname;

  const isCheckMarkVariation = Boolean(locationPath.includes('/check_mark'));

  const mainTitle = getTitleByUrlPart(partUrl);

  const getSubtitle = () => {
    if (isCheckMarkVariation && isCheckMarkLY) {
      return t('check_mark_ly_input_instruction');
    }

    if (isCheckMarkVariation) {
      return isAE(homeData.country) ? t('special_check_mark_subtitle') : '';
    }

    return subTitle;
  };

  if (!homeData.source) {
    return null;
  }

  return (
    <div className={styles.bannerTitleV5Container}>
      {homeData.source === V5_DOWNLOAD_ICON_TRIAL && isMY(homeData.country) ? null : (
        <div className={styles.bannerTitleV5MainText}>{t(mainTitle)}</div>
      )}
      {homeData.source === V5_DOWNLOAD_ICON_TRIAL && isMY(homeData.country) ? null : (
        <div
          className={styles.bannerTitleV5SecondaryText}
          style={
            isCheckMarkVariation ? { marginTop: '8px', textAlign: 'center', fontSize: '10px' } : {}
          }
        >
          {getSubtitle()}
        </div>
      )}
    </div>
  );
};

const getTitleByUrlPart = (urlPart: string | null = null) => {
  const locationPath = urlPart || window.location.pathname;

  if (locationPath.includes('/check_mark')) {
    return '';
  }

  if (locationPath.includes('/download_icon')) {
    return 'your_file_is_ready';
  }

  if (locationPath.includes('/phone_icon')) {
    return 'your_file_is_ready';
  }

  return '';
};
